
import PropTypes from 'prop-types';
import IWindow from '@bingads-webui-clientcenter/window-interface';
import type { GenericPidlProps } from './types';

const PropTypesObjectOfArrayOfStrings = PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string));

const PidlUtilBaseShape = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  enabledCountries: PropTypesObjectOfArrayOfStrings.isRequired,
  excludedCountriesByCard: PropTypesObjectOfArrayOfStrings.isRequired,
  pidlErrorFormatMapping: PropTypesObjectOfArrayOfStrings.isRequired,
  authenticationType: PropTypes.string.isRequired,
  msaAuth: PropTypes.shape({
    clearMsaDelegateCookie: PropTypes.func.isRequired,
    authenticate: PropTypes.func.isRequired,
  }).isRequired,
  pifdAuth: PropTypes.func.isRequired,
  paymentAsAServiceApi: PropTypes.shape({
    createWalletReq: PropTypes.func.isRequired,
    associatePaymentInstrument: PropTypes.func.isRequired,
    paymentInstrumentAssociateV2: PropTypes.func.isRequired,
  }),
  pidlService: PropTypes.shape({
    getAddressList: PropTypes.func.isRequired,
    addOrUpdatePI: PropTypes.func.isRequired,
    getPidlInfo: PropTypes.func.isRequired,
  }).isRequired,
  ThreatMetrixUrl: PropTypes.string.isRequired,
  GreenIdUrl: PropTypes.string.isRequired,
  verificationToken: PropTypes.string.isRequired,
  redirect: PropTypes.func,
};

export const PropTypesGenericPidl = {
  ...PidlUtilBaseShape,
  pidlLogger: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
  ])),
  culture: PropTypes.string.isRequired,
  supportedCultureMapping: PropTypes.objectOf(PropTypes.string).isRequired,
  pidlEnvironment: PropTypes.string.isRequired,
  testHeader: PropTypes.string,
};

export const PropTypesDefaultGenericPidl: Partial<GenericPidlProps> & { redirect: (url: string) => void } = {

  pidlLogger: null,

  redirect: (url: string) => {
    IWindow.location.href = url;
  },

  testHeader: null,
};

export type { GenericPidlProps, PidlUtilLike } from './types';

export const PidlUtilShape = PropTypes.shape({
  ...PidlUtilBaseShape,
  piTypes: PropTypes.objectOf(PropTypes.string).isRequired,
  supportedCardTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  language: PropTypes.string.isRequired,
  pidlDocParameters: PropTypes.shape({
    language: PropTypes.string.isRequired,
    partner: PropTypes.string.isRequired,
  }).isRequired,
  pidlErrorFormatMapping: PropTypesObjectOfArrayOfStrings.isRequired,
  logger: PropTypes.shape({
    authFail: PropTypes.func.isRequired,
    pidlFail: PropTypes.func.isRequired,
    setOptions: PropTypes.func.isRequired,
    setOptionsAction: PropTypes.func.isRequired,
    setPidlOption: PropTypes.func.isRequired,
    addTaps: PropTypes.func.isRequired,
    start: PropTypes.func.isRequired,
    succeed: PropTypes.func.isRequired,
    validationFail: PropTypes.func.isRequired,
    userFail: PropTypes.func.isRequired,
    clearOptions: PropTypes.func.isRequired,
  }).isRequired,
  getPidlInstance: PropTypes.func.isRequired,
  getRiskData: PropTypes.func.isRequired,
  addOrUpdatePI: PropTypes.func.isRequired,
});
